import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/utilities.css';
import './assets/css/custom.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import { IconSettings } from '@salesforce/design-system-react';

ReactDOM.render(
    <IconSettings iconPath="icons">
        <App />
    </IconSettings>,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js